import { defineStore, acceptHMRUpdate } from 'pinia'
import { STORAGE_KEYS } from '@/libs/utils/constants.ts'
interface StoreApp {
  theme: string
  size: string
}
export const useAppStore = defineStore({
  id: STORAGE_KEYS.APP_INFO,
  state: (): StoreApp => ({
    theme: 'brown',
    size: 'default',
  }),
  getters: {
    getTheme: (state: StoreApp) => {
      return state.theme
    },
    getSize: (state: StoreApp) => {
      return state.size
    },
  },
  actions: {
    setTheme(data: any) {
      this.theme = data
    },
    setSize(data: any) {
      this.size = data
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        storage: localStorage,
        // paths: ['token'], //可以选择保存的字段  其余的不保存
      },
    ],
  },
})
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot))
}
